// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2PXn4","modalFooterButton":"ModalNotes_modalFooterButton__2yKHD"};